import * as React from 'react'

export const SvgSezzle = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 798.16 199.56"
    width={80}
    height={24}
    aria-hidden={true}
    {...props}
  >
    <defs>
      <linearGradient
        id="sezzle_svg__a"
        x1={76.86}
        y1={65.86}
        x2={44.43}
        y2={104.51}
        gradientTransform="matrix(1 0 0 -1 0 202)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#ce5dcb" />
        <stop offset={0.21} stopColor="#c558cc" />
        <stop offset={0.55} stopColor="#ac4acf" />
        <stop offset={0.98} stopColor="#8534d4" />
        <stop offset={1} stopColor="#8333d4" />
      </linearGradient>
      <linearGradient
        id="sezzle_svg__b"
        x1={78.04}
        y1={109.85}
        x2={147.73}
        y2={109.85}
        gradientTransform="matrix(1 0 0 -1 0 202)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.02} stopColor="#ff5667" />
        <stop offset={0.66} stopColor="#fc8b82" />
        <stop offset={1} stopColor="#fba28e" />
      </linearGradient>
      <linearGradient
        id="sezzle_svg__c"
        y1={134.9}
        x2={95.92}
        y2={134.9}
        gradientTransform="matrix(1 0 0 -1 0 202)"
        gradientUnits="serSpaceOnUse"
      >
        <stop offset={0} stopColor="#00b874" />
        <stop offset={0.51} stopColor="#29d3a2" />
        <stop offset={0.68} stopColor="#53dfb6" />
        <stop offset={1} stopColor="#9ff4d9" />
      </linearGradient>
      <linearGradient
        id="sezzle_svg__d"
        x1={65.36}
        y1={69.54}
        x2={161.28}
        y2={69.54}
        gradientTransform="matrix(1 0 0 -1 0 202)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#fcd77e" />
        <stop offset={0.52} stopColor="#fea500" />
        <stop offset={1} stopColor="#ff5b00" />
      </linearGradient>
    </defs>
    <path
      d="M13.54 134.2a46.21 46.21 0 0065.36 0l1.73-1.73c9-9-9-56.34 0-65.36z"
      fill="url(#sezzle_svg__a)"
    />
    <path
      d="M82.37 65.37l-1.73 1.73c-9 9 9 56.34 0 65.36l67.09-67.09a46.23 46.23 0 00-65.36 0"
      fill="url(#sezzle_svg__b)"
    />
    <path
      d="M13.54 68.84a46.21 46.21 0 000 65.36l68.84-68.84a46.21 46.21 0 000-65.36z"
      fill="url(#sezzle_svg__c)"
    />
    <path
      d="M78.9 134.2a46.21 46.21 0 000 65.36l68.84-68.84a46.21 46.21 0 000-65.36z"
      fill="url(#sezzle_svg__d)"
    />
    <path
      fill={props.fill || '#382757'}
      d="M415.54 100.14a51.52 51.52 0 00-24.79-30.79 52 52 0 00-39.29-4.22 51.63 51.63 0 00-35.06 64v.13c.88 2.94 2.29 6.7 2.32 6.76 4.39 10.28 11.75 18.13 22.48 24a51.7 51.7 0 0064.81-12.73l.42-.52a50.33 50.33 0 004.57-6.87 8.8 8.8 0 00-15.35-8.59 33.59 33.59 0 01-8.55 10 5.81 5.81 0 00-.74.68 34.23 34.23 0 01-36.75 2.56 33.6 33.6 0 01-12.71-12.26L409.6 111a8.77 8.77 0 005.94-10.86zm-49.49-19.61a34.24 34.24 0 0128.6 15.6l.52.83-63.27 18.56a34.15 34.15 0 0124.49-33.59 34.41 34.41 0 019.66-1.4zm39.43 66zm103.33 3.08h-48.08l53.77-79a4.86 4.86 0 00-4-7.6h-68.38a8.23 8.23 0 000 16.46h45.81l-53.75 79a4.85 4.85 0 004 7.59h70.6a8.23 8.23 0 000-16.45zm106.52 0h-48.07l53.76-79A4.85 4.85 0 00617 63h-68.35a8.23 8.23 0 000 16.46h45.81l-53.75 79a4.85 4.85 0 004 7.59h70.6a8.23 8.23 0 000-16.46zM662.8 18.47a8.24 8.24 0 00-8.23 8.23v131.43a8.23 8.23 0 0016.46 0V26.7a8.24 8.24 0 00-8.23-8.23zm135.01 81.68A51.44 51.44 0 00773 69.36a52 52 0 00-39.29-4.22 51.65 51.65 0 00-35.06 64v.14c.88 2.93 2.29 6.69 2.32 6.76 4.39 10.28 11.75 18.12 22.48 24a51.69 51.69 0 0064.8-12.72l.43-.55a51.66 51.66 0 004.55-6.8 8.8 8.8 0 00-15.23-8.64 33.58 33.58 0 01-8.54 10 6 6 0 00-.75.68 34.26 34.26 0 01-36.76 2.56 33.53 33.53 0 01-12.71-12.26L791.87 111a8.77 8.77 0 005.94-10.85zm-49.48-19.62a34.24 34.24 0 0128.6 15.6l.52.83-63.27 18.56a34.18 34.18 0 0134.15-35zm-459.5 39.78a27.63 27.63 0 00-10.47-8.85c-7.37-3.75-16.92-5.47-26.08-6.9l-1.45-.22c-6.43-1-13.08-2-17.35-4.2-3.23-1.64-4.38-3.48-4.38-7.07 0-6.95 7.57-12.19 17.6-12.19 12 0 18.66 3.5 26.16 8.07a8.86 8.86 0 109.24-15.13 76.25 76.25 0 00-14.42-7.24 61.22 61.22 0 00-21-3.44c-9.24 0-17.89 2.81-24.34 7.91a27.72 27.72 0 00-11 22c0 10.3 4.88 18.22 14.11 22.89 6.78 3.43 14.84 4.68 22.63 5.89l1.44.22c20 3.13 25.76 6 25.76 12.56 0 8.19-8.2 13.55-20.89 13.66H254a41.34 41.34 0 01-25.36-8c-.68-.46-1.26-.87-1.84-1.23a8.87 8.87 0 00-9.39 15c.23.14.58.38 1 .65l.24.16A59.12 59.12 0 00254 166h.61c11-.1 20.48-3.06 27.38-8.58A28.78 28.78 0 00293 134.64a25 25 0 00-4.17-14.33z"
    />
  </svg>
)
export default SvgSezzle
